import __vue_component__ from '../Button/Button.vue.js';
import { chunk } from '../../utils/utils.js';

//
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const MONTHS_PER_ROW = 3;
var script = {
  name: 'Months',
  components: {
    Button: __vue_component__
  },
  computed: {
    monthsOfYear() {
      return chunk(MONTHS, MONTHS_PER_ROW);
    }

  },
  methods: {
    onMonthSelected(month) {
      const index = MONTHS.indexOf(month);
      this.$emit('month-selected', index);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Calendar/Months.vue_rollup-plugin-vue=script.js